/**
 * El mes natural en curso, para el Inicio de RH (SRH-340).
 *
 * Del día 1 al último día del mes, contado en la zona del negocio (México) y no
 * en la del navegador: a partir de las 6 p.m. del último día del mes ya es el
 * mes siguiente en UTC, y una cuenta con la zona del equipo mostraría el mes
 * equivocado a quien trabaja de noche.
 */

const ZONA_DEL_NEGOCIO = 'America/Mexico_City'

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
]

export interface PeriodoDelInicio {
  /** YYYY-MM-DD, primer día del mes. */
  dateFrom: string
  /** YYYY-MM-DD, último día del mes. */
  dateTo: string
  /** `Noviembre 2026`, como se muestra en el encabezado. */
  etiqueta: string
  /** `noviembre de 2026`, para frases como «creadas en noviembre de 2026». */
  enFrase: string
}

const formateador = new Intl.DateTimeFormat('en-CA', {
  timeZone: ZONA_DEL_NEGOCIO,
  year: 'numeric',
  month: '2-digit',
})

const dosDigitos = (n: number) => String(n).padStart(2, '0')

export const mesNaturalEnMexico = (ahora: Date = new Date()): PeriodoDelInicio => {
  const partes = formateador.formatToParts(ahora)
  const anio = Number(partes.find((p) => p.type === 'year')?.value)
  const mes = Number(partes.find((p) => p.type === 'month')?.value)
  // Día 0 del mes siguiente = último día de este. Aritmética en UTC, donde un día siempre dura 24 horas.
  const ultimoDia = new Date(Date.UTC(anio, mes, 0)).getUTCDate()
  const nombre = MESES[mes - 1]

  return {
    dateFrom: `${anio}-${dosDigitos(mes)}-01`,
    dateTo: `${anio}-${dosDigitos(mes)}-${dosDigitos(ultimoDia)}`,
    etiqueta: `${nombre.charAt(0).toUpperCase()}${nombre.slice(1)} ${anio}`,
    enFrase: `${nombre} de ${anio}`,
  }
}
